export default __webpack_public_path__ + "static/media/phone-mock-up.1e570b3b.png";